<template>
  <header @click="isDialogVisible = false">
    <div class="top-bar">
      <RouterLink to="/" exact-active-class="active">
        <img
          src="@/assets/jkt/logoJKT.png"
          alt="JKT Logo"
          class="logo"
          style="block-size: auto; inline-size: 70%"
        />
      </RouterLink>
      <div class="nav-links text-decoration-none">
        <RouterLink to="/"> <i class="fas fa-chart-bar" /> UTAMA </RouterLink>
        <RouterLink v-if="authStore.isAuthenticated && authStore.user" to="">
          {{ authStore.user.name }}
        </RouterLink>

        <div
          class="absolute inset-y-0 right-0 flex items-center sm:static sm:inset-auto sm:ml-6 sm:pr-0"
        >
          <!-- Profile dropdown -->
          <div class="relative">
            <div class="user-icon" @click.stop="toggleDialog">
              <i
                class="fas fa-circle-user fa-2x cursor-pointer shadow-lg rounded-full"
              />
            </div>

            <!-- Dropdown menu -->
            <div
              v-if="isDialogVisible"
              class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="user-menu-button"
              tabindex="-1"
              style="background-color: rgba(255, 255, 255, 20%)"
              @click.stop
            >
              <!-- Log Masuk: Visible when user is not authenticated -->
              <RouterLink
                v-if="!authStore.isAuthenticated"
                to="/login"
                class="block px-4 py-2 text-sm"
              >
                Log Masuk
              </RouterLink>

              <!-- Pengurusan Pengguna & Pengguna API: Visible only for Manager -->
              <RouterLink
                v-if="authStore.isAuthenticated && isManager"
                to="/pengurusan-pengguna"
                class="block px-4 py-2 text-sm"
                role="menuitem"
                tabindex="-1"
              >
                Pengurusan Pengguna
              </RouterLink>
              <!-- <RouterLink
                v-if="authStore.isAuthenticated && isManager"
                to="/pengguna-api"
                class="block px-4 py-2 text-sm"
                role="menuitem"
                tabindex="-1"
              >
                Pengguna API
              </RouterLink> -->

              <!-- Log Keluar: Visible when user is authenticated -->
              <RouterLink
                v-if="authStore.isAuthenticated"
                to=""
                class="block px-4 py-2 text-sm"
                exact-active-class="active"
                @click="authStore.logout(router)"
              >
                Log keluar
              </RouterLink>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isHomepage" class="welcome-text text-center">
      <img
        src="@/assets/jkt/HomePage/selamat.png"
        alt="Selamat Datang Ke"
        class="welcome-image"
      />
      <img
        src="@/assets/jkt/HomePage/jktgateway2.png"
        alt="JKTGATEWAY"
        class="gateway-image"
      />
      <hr class="underline" />
    </div>
  </header>
</template>

<script setup>
import { useAuthStore } from "@/store/auth";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useRouter } from "vue-router";

const props = defineProps({
  isHomepage: {
    type: Boolean,
    default: false,
  },
  closeDialog: {
    type: Boolean,
    required: true,
  },
});

const router = useRouter();
const authStore = useAuthStore();

const isDialogVisible = ref(false);

const toggleDialog = () => {
  isDialogVisible.value = !isDialogVisible.value;
};

const handleClickOutside = (event) => {
  const dropdown = document.querySelector(".user-icon");
  if (dropdown && !dropdown.contains(event.target)) {
    isDialogVisible.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

const isManager = computed(() => {
  const roles = authStore.getRoles();

  return roles.some((role) => role.toLowerCase() === "manager");
});

watch(
  () => isDialogVisible.value,
  (newValue) => {
    console.log("Dropdown visibility:", newValue);
  }
);
</script>

<style scoped>
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-block: 0;
  margin-inline: auto;
  max-inline-size: 90%;
  padding-block: 10px;
  padding-inline: 20px;
}

.logo {
  block-size: 45px;
  margin-top: 10px;
}

.nav-links {
  display: flex;
  gap: 30px;
  text-decoration: underline;
}

.nav-links a {
  color: white;
  font-size: 1rem;
  text-decoration: none;
}

.nav-links a:hover {
  text-decoration: underline;
}

.welcome-image {
  display: block;
  block-size: auto;
  margin-block: 0;
  margin-inline: auto;
  max-inline-size: 40%;
}

.welcome-text {
  margin-block-start: -40px;
  margin-inline: auto;
  max-inline-size: 40%;
  text-align: center;
}

.gateway-image {
  display: block;
  margin-block: 0;
  margin-inline: auto;
  max-width: 500px; /* or a percentage like 50% */
  height: auto; /* maintain aspect ratio */
}

.underline {
  border: none;
  border-top: 5px solid white;
  width: 100%;
}
</style>
